import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/ecom_tamil_logo.png";

export default function Footer() {
  return (
    <div>
      <footer className="bg-gradient-to-b from-white to-amber-50/70 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center text-center md:text-left mb-16">
            <div>
              <div className="flex items-center justify-center md:justify-start space-x-2 mb-6">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-16 w-auto"
                />
                <span className="font-semibold text-2xl text-gray-900 tracking-tight"></span>
              </div>
              <p className="text-gray-500 font-medium max-w-sm mx-auto md:mx-0">
                Join 15,000+ students building the future of digital commerce.
              </p>
            </div>
            <div className="flex justify-center md:justify-end space-x-12">
              <div>
                <h4 className="text-xs font-semibold text-amber-600 uppercase tracking-widest mb-4">
                  Resources
                </h4>
                <ul className="space-y-2 text-sm font-semibold text-gray-600">
                  <li>
                    <Link
                      to="/terms_conditions"
                      className="hover:text-amber-600 cursor-pointer"
                    >
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/refund_policy"
                      className="hover:text-amber-600 cursor-pointer"
                    >
                      Refund Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacy_policy"
                      className="hover:text-amber-600 cursor-pointer"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="pt-8 border-t border-amber-200 text-center text-sm font-semibold text-amber-700 capitalize">
            © 2026 Ecom Tamil. All Rights Reserved
          </div>
        </div>
      </footer>

    </div>
  );
}
